import * as Cookie from 'js-cookie';
import { find, get } from 'lodash';
import * as React from 'react';
import { Authorize } from '../libs/authorize';
import './header.component.scss';
// tslint:disable

export class HeaderComponent extends React.Component {

    public headerClasses: any = {
        'local': {
            1: 'bg-gradient-3',
            2: 'bg-gradient-5',
        },
        'uat': {
            1: 'bg-gradient-6',
            2: 'bg-gradient-7',
        },
        'prod': {
            1: 'bg-gradient-8',
            2: 'bg-gradient-9',
        },
        'dev': {
            1: 'bg-gradient-2',
            2: 'bg-gradient-3',
        }
    }
    public state: any = {
        site: {},
        sites: [],
        user: {},
        // headerClass: (window as any).API_META_ENV.headerGradientClass,
        nodeEnv: (window as any).API_META_ENV.env,
        headerClass: ''
    };

    componentDidMount() {
        try {
            this.setState({
                site: JSON.parse(Cookie.get('site') as string),
                sites: JSON.parse(Cookie.get('sites') as string),
                user: JSON.parse(Cookie.get('user') as string),
                headerClass: this.headerClasses[(window as any).API_META_ENV.env][JSON.parse(Cookie.get('site') as string).id]
            });

            // console.log(this.headerClasses)
            // console.log(this.headerClasses[(window as any).API_META_ENV.env])
            // console.log(this.headerClasses[(window as any).API_META_ENV.env][JSON.parse(Cookie.get('site') as string).id])
        } catch (err) {
            //alert(`SWW: ${err.message}`);
            //window.location.href = '/login';
        }
    }

    handleSiteSelect(event: any) {
        const site = find(this.state.sites, (s: any) => s.id.toString() === event.target.value);
        Cookie.set('site', site);
        window.location.reload(true);
    }

    render() {
        return (
            <div id="page-header" className={this.state.headerClass}>
                <div id="mobile-navigation">
                    <button id="nav-toggle" className="collapsed" data-toggle="collapse" data-target="#page-sidebar">
                        <span></span></button>
                </div>
                <div id="header-logo" className="logo-bg">
                    <a href="/">
                        <img src="/images/jacobs.svg" alt="Jacobs logo"/>
                    </a>
                </div>
                <div id="header-nav-left">
                    <div className="user-account-btn dropdown">
                        <a href="#" title="My Account" className="user-profile clearfix float-left" data-toggle="dropdown">
                            <i className="fa fa-fw fa-user fa-2x pull-left"/>
                            {/*<img width="28" src="image-resources/gravatar.jpg" alt="Profile image"/>*/}
                            <span>{get(this.state.user, 'firstName')}</span>
                            <i className="glyph-icon fa-fw fa fa-angle-down"/>
                        </a>
                        <div className="dropdown-menu float-left">
                            <div className="box-sm">
                                <div className="login-box clearfix">
                                    <div className="user-img">
                                        {/*<a href="#" title="" className="change-img">Change photo</a>*/}
                                        <i className="fa fa-fw fa-user"/>
                                        <img src="image-resources/gravatar.jpg" alt=""/>
                                    </div>
                                    <div className="user-info">
                                        <span>
                                            {get(this.state.user, 'firstName')} {get(this.state.user, 'surName')}
                                            {/*<i>UX/UI developer</i>*/}
                                        </span>
                                        <a href={`/user/${get(this.state.user, 'id')}`} title="Edit profile">Edit
                                            profile</a>
                                        {/*<a href="#" title="View notifications">View notifications</a>*/}
                                    </div>
                                </div>
                                <div className="divider"></div>
                                {/*<ul className="reset-ul mrg5B">
                                    <li>
                                        <a href="#">
                                            <i className="glyph-icon float-right icon-caret-right"/>
                                            View login page example
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="glyph-icon float-right icon-caret-right"/>
                                            View lockscreen example

                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="glyph-icon float-right icon-caret-right"/>
                                            View account details

                                        </a>
                                    </li>
                                </ul>*/}
                                <div className="pad5A button-pane button-pane-alt text-center">
                                    <a href="#" className="btn display-block font-normal btn-danger"
                                       onClick={() => Authorize.logout()}>
                                        <i className="glyph-icon icon-power-off"/> Logout
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="float-left">
                            <h1 className="headerSiteTitle"><b>{this.state.nodeEnv}</b>.{ this.state.site.domain }</h1>
                        </div>
                    </div>
                </div>
                <div id="header-nav-right">
                    <span className="hdr-btn pointer">
                        <select title="change project" className="site-selector-select" value={this.state.site.id}
                                onChange={(event: any) => this.handleSiteSelect(event)}>
                            {(this.state.sites || []).map((site: any, index: number) => {
                                return <option key={index} value={site.id}>SITE: {site.name}</option>;
                            })}
                        </select>
                    </span>
                    <a href="#" className="hdr-btn pointer" title="Logout">
                        <i className="fa fa-fw fa-sign-out" onClick={() => Authorize.logout()}/>
                    </a>
                </div>

            </div>
        );
    }
}
// selected={this.state.site.id === site.id}



// WEBPACK FOOTER //
// ./src/components/structurals/header.component.tsx